import axios from 'axios'
import moment from 'moment'
import { getConectToken } from './HttpRequestAPI'
import {toast, dismissLoading} from '../utils'
import store from '../store/index'
import {getLoginToken, setLoginToken} from '../cache/Cache'
import Constant from '../constant/index'
import router from '@/router'


const API_HOST = Constant.API_HOST

axios.defaults.headers = {
}
axios.defaults.timeout = 120 * 1000
// 默认是false，意思就是不携带cookie信息
// axios.defaults.withCredentials = true

// 添加请求拦截器
axios.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error)
})


export const post = (des, url, body = {}, success = () => { }, fail = () => { }) => {
  let loginToken = getLoginToken()
  const headers = {
    'Content-Type': 'application/json;charset=utf-8',
    'xc_sso_sessionid': loginToken ? loginToken : '',
  }

  axios({
    method: 'post',
    url: API_HOST + url,
    data: body,
    headers: headers
  }).then(res => {
    handleResp(des, 'post', url, body, res, success, fail)
  })
}


// 上传文件
export const uploadFile = (des, url, body, success = () => { }, fail = () => { }) => {
  let clientSessionId = store.getters.getConnectToken
  let loginToken = global.loginToken ? global.loginToken : getLoginToken()
  let headers = {
    'Content-Type': 'multiple/form-data',
    'xc_sso_sessionid': loginToken,
  }

  axios({
    method: 'post',
    url: API_HOST + url,
    // type:'json',
    data: body,
    headers
  }).then(res => {
    handleResp(des, 'upload', url, body, res, success, fail)
  }).catch(error => {
    console.log(error)
  })
}

/** 添加公共的参数并进行加密处理 */
const commonParam = (param) => {
  param.msgId = moment().utcOffset(8).format('YYYYMMDDHHmmss') + parseInt(Math.random() * 1000000)
  param.channelDate = moment().utcOffset(8).format('YYYYMMDD')
  param.channelSerialNo = moment().utcOffset(8).format('YYYYMMDDHHmmss') + parseInt(Math.random() * 1000000)
  param.transChannel = 'h5'
  param.channelTime = moment().utcOffset(8).format('YYYY-MM-DD HH:mm:ss')


  let bodyStr = JSON.stringify(param)

  return bodyStr
}

/** 对返回结果进行处理 */
const handleResp = (des, type, url, body, resp, success, fail) => {
  let data = resp.data
  let status = resp.status
  if (status === 200) {
    if (data.code === 200) {
      let res = data
      success(res)
    } else if(data.code === 401) {
      //登录过期
      toast(data.msg)
      setLoginToken('')
      router.push('/login')
    } else if (data.code === 80000001) {
      getConectToken(res => {
        store.commit('setConnectToken', res.result.connectToken)
        if (type === 'post') {
          post(des, url, body, success, fail)
        }
      })
    } else {
      failCallback(fail, createFailRespObj(data.msg), body)
    }
  } else {
    failCallback(fail, createFailRespObj('服务器异常'), body)
  }
}

const failCallback = (failCallback, resp, body) => {
  if (resp && resp.msg && !body.unshowMsg) {
    toast(resp.msg)
    dismissLoading()
  }
  if (failCallback) {
    failCallback(resp)
  }
}

const createFailRespObj = (errorMsg) => {
  return { msg: errorMsg }
}
